import PhotoSwipeGallery from 'react-photoswipe-2/lib/PhotoSwipeGallery';
import '../../../../../../../node_modules/react-photoswipe-2/lib/photoswipe.css';
export default PhotoSwipeGallery;
